<template>
  <div
    class="pa-2"
  >
    <v-row class="mb-n10 font-calibri">
      <v-col>
        <div class="expand-scroll-container">
          <div class="approval-flow">
            <div
              v-for="(workflow, index) in claimApprovalWorkflowBatch.claim_approval_workflows"
              :key="workflow.approval_level"
              class="flow-item"
            >
              <v-card
                outlined
                class="pa-3 text-center"
                color="light-blue lighten-4"
              >
                <div class="font-weight-bold">
                  <span>Level {{ workflow.approval_level }}</span>
                  <span v-if="workflow.approving_verb"> ({{ workflow.approving_verb }})</span>
                </div>
                <div v-if="workflow.approvable_name === 'Superior'">
                  {{ workflow.approvable_name }}
                </div>
                <div v-else>
                  {{ getText(workflow) + workflow.approvable_type_name }}
                </div>
              </v-card>

              <!-- Arrow -->
              <v-icon
                v-if="index < claimApprovalWorkflowBatch.claim_approval_workflows.length - 1"
                large
                class="mx-4"
              >
                mdi-arrow-right
              </v-icon>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    props: {
      claimApprovalWorkflowBatch: {
        type: Object,
        required: true,
      },
    },
    methods: {
      getText (workflow) {
        switch (workflow.approvable_type) {
          case 'App\\Model\\Department':
            return 'Department: '
          case 'App\\Model\\Position':
            return 'Position: '
          case 'App\\Model\\Employee':
            return 'Specific Employee: '
          default:
            return null
        }
      },
    },
  }
</script>

<style scoped>
.expand-scroll-container {
  width: 100%;                 /* always fit table cell */
  overflow-x: auto;            /* horizontal scroll */
  overflow-y: hidden;
}

.approval-flow {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  width: max-content;          /* content decides width, but scrolls */
}

.flow-item {
  display: flex;
  align-items: center;
}

.font-calibri{
    font-family: Calibri !important;
}

.font-16{
    font-size:16px;
}

.accordion-max-height{
  max-height: 36px !important;
}
</style>
